import { render, staticRenderFns } from "./CheckTypeASelector.vue?vue&type=template&id=13c82a62&scoped=true"
import script from "./CheckTypeASelector.vue?vue&type=script&lang=js"
export * from "./CheckTypeASelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c82a62",
  null
  
)

export default component.exports